import { AxiosHttpError, FormErrorsResponse, HttpErrorResponse } from './Http.types';

class HttpError implements HttpErrorResponse<FormErrorsResponse> {
  public readonly message: string;
  public readonly code: number | string;
  public readonly errors?: { form: FormErrorsResponse };
  /**
   * The server's response body, kept as-is.
   *
   * `message` flattens it to one string, which is enough for a toast and not enough for
   * diagnosis: a 415 from the transcription endpoint also carries `received_type`, the MIME
   * type the server sniffed from the file CONTENT, and that single field is what separates
   * an empty recording from a container missing its header from a type simply absent from
   * the allow-list. It was being dropped here, so every caller that tried to log it recorded
   * "unknown".
   */
  public readonly responseData?: Record<string, unknown>;

  constructor(error: AxiosHttpError) {
    this.message =
      error.response?.data.message ??
      error.response?.data.error ??
      error.message ??
      'Unknown error';
    this.code = error.response?.status ?? error.code ?? 0;
    this.errors = error.response?.data?.errors;
    this.responseData = error.response?.data;
  }
}

export { HttpError };
